
import { defineComponent } from "vue";
import {passwordStrength} from 'check-password-strength';

export default defineComponent({
    name: "v-passmeter",
  
    props: {
        value: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            length: 0,
            password: '',
            percentage: 0,
            color: 'bg-red-400',
            message: 'Poor',
            text_color: 'text-gray-500',
        }
    },
    methods: {
        getPercentage() {
            return this.percentage + '%';
        },
    },
    watch: {
        value(n : any) {

             this.message = passwordStrength(n).value;
             
            if(passwordStrength(n).value == "Too weak"){
                this.text_color = 'text-red-500';
            }
            if(passwordStrength(n).value == "Weak"){
                this.text_color = 'text-yellow-500';
            }
            if(passwordStrength(n).value == "Medium"){
                this.text_color = 'text-yellow-400';
            }
            if(passwordStrength(n).value == "Strong"){
                this.text_color = 'text-green-500';
            }
            this.$emit('score',this.message);
        
        },
        percentage(val : any) {
            if(val < 30)
            {
                this.message = 'Very Poor';
                this.color = 'bg-red-400';
            }
            else if(val >= 30 && val < 50)
            {
                this.message = 'Poor';
                this.color = 'bg-yellow-400';
            }
            else if(val >= 50 && val < 70)
            {
                this.message = 'Good';
                this.color = 'bg-green-400';
            }
            else if(val >= 70 && val < 100)
            {
                this.message = 'Very Good';
                this.color = 'bg-green-600';
            }
        }
    },
})
